export default {
    "equipment_types": {
        "titles": "Tipos de Equipamento",
        "title": "Tipo de Equipamento",
        "list": {
            "name": "Nome"
        },
        "model": {
            "name": "Nome"
        }
    },
    "green_space_types": {
        "titles": "Espaços Verdes",
        "title": "Espaço Verde",
        "list": {
            "name": "Nome"
        },
        "model": {
            "name": "Nome"
        }
    },
    "license_file_types": {
        "titles": "Tipos de Ficheiro",
        "title": "Tipo de Ficheiro",
        "list": {
            "name": "Nome",
            "order": "Ordem"
        },
        "model": {
            "name": "Nome",
            "description": "Descrição",
            "order": "Ordem"
        }
    },
    "license_guarantee_owners": {
        "titles": "Titulares de Caução",
        "title": "Titular de Caução",
        "list": {
            "name": "@:license_guarantee_owners.model.name",
        },
        "model": {
            "name": "Nome"
        }
    },
    "license_guarantee_types": {
        "titles": "Tipos de Caução",
        "title": "Tipo de Caução",
        "list": {
            "name": "@:license_guarantee_types.model.name",
            "status": "@:license_guarantee_types.model.status"
        },
        "model": {
            "name": "Nome",
            "status": "Ativo"
        }
    },
    "license_guarantee_states": {
        "titles": "Estados de Caução",
        "title": "Estado de Caução",
        "list": {
            "name": "@:license_guarantee_states.model.name",
            "status": "@:license_guarantee_states.model.status"
        },
        "model": {
            "name": "Nome",
            "status": "Ativo"
        }
    },
    "license_owners": {
        "titles": "Titulares",
        "title": "Titular",
        "list": {
            "name": "Nome"
        },
        "model": {
            "name": "Nome"
        }
    },
    "license_statuses": {
        "titles": "Estados de Alvará",
        "title": "Estado de Alvará",
        "list": {
            "name": "Nome"
        },
        "model": {
            "name": "Nome",
            "description": "Descrição"
        }
    },
    "license_types": {
        "titles": "Tipos de Alvará",
        "title": "Tipo de Alvará",
        "list": {
            "name": "Nome"
        },
        "model": {
            "name": "Nome"
        }
    },
    "license_use_types": {
        "titles": "Usos de Alvará",
        "title": "Uso de Alvará",
        "list": {
            "name": "Nome"
        },
        "model": {
            "name": "Nome"
        }
    },
    "lot_use_types": {
        "titles": "Usos de Loteamento",
        "title": "Uso de Loteamento",
        "list": {
            "name": "Nome"
        },
        "model": {
            "name": "Nome"
        }
    },
    "places": {
        "titles": "Locais",
        "title": "Local",
        "list": {
            "name": "Nome"
        },
        "model": {
            "name": "Nome"
        }
    },
}
